<template>
  <div class="form-container">
    <div class="form-header">
      <h2>{{ isEditing ? 'Edit Organization Role' : 'Create New Organization Role' }}</h2>
    </div>
    <form @submit.prevent="handleSubmit" class="form">
      <div class="form-section">
        <h3>Role Details</h3>
        <div class="form-group">
          <label for="name">Name</label>
          <input 
            id="name"
            v-model="formData.name"
            type="text"
            required
            placeholder="Enter role name"
            class="form-control"
          />
        </div>

        <div class="form-group full-width">
          <label for="description">Description</label>
          <textarea
            id="description"
            v-model="formData.description"
            placeholder="Enter role description"
            rows="3"
            class="form-control"
          ></textarea>
        </div>
      </div>

      <div class="form-actions">
        <button type="submit" class="submit-button big">
          {{ isEditing ? 'Save Changes' : 'Create Role' }}
        </button>
        <button type="button" class="cancel-button medium" @click="handleCancel">
          Cancel
        </button>
      </div>
    </form>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import axios from 'axios';
import { handleApiError } from '@/scripts/shared-utils';

const route = useRoute();
const router = useRouter();
const roleId = computed(() => route.params.id);
const isEditing = ref(false);

const formData = ref({
  name: '',
  description: ''
});

async function loadRole() {
  if (isEditing.value) {
    try {
      const response = await axios.get(`/api/roles/${roleId.value}`);
      formData.value = {
        name: response.data.name,
        description: response.data.description
      };
    } catch (error) {
      handleApiError(error, 'loading role');
      router.push('/admin/permissions');
    }
  }
}

async function handleSubmit() {
  try {
    if (isEditing.value) {
      const editableFields = [
        'name',
        'description'
      ];
      
      const payload = {};
      editableFields.forEach(field => {
        if (field in formData.value) {
          payload[field] = formData.value[field];
        }
      });
      
      await axios.put(`/api/roles/${roleId.value}`, payload);
    } else {
      await axios.post('/api/roles', formData.value);
    }
    router.push('/admin/permissions');
  } catch (error) {
    handleApiError(error, isEditing.value ? 'updating role' : 'creating role');
  }
}

function handleCancel() {
  router.back();
}

onMounted(() => {
  isEditing.value = roleId.value ? true : false;
  loadRole();
});
</script>

<style scoped>
@import '@/styles/shared-form.css';
</style>
